import { isTag, isElementNode } from 'anodum';
import findRootEditableElement from './find-root-editable-element';
import { findNextEditableElement, findEditableElement } from './find-editable-element';
import setCaretInTheEndOfNode from './set-caret-in-the-end-of-node';
import isBreakElement from '../verifiers/is-break-element';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import view from '../../view';

const handleRemoveNextEmptyElement = () => {
  const selection = view.accessors.getSelection();

  requestAnimationFrame(() => {
    const { anchorNode } = selection;

    const editableElement = findRootEditableElement(anchorNode);

    if (!editableElement) {
      /*
       * In Safari browser, if some element has `position: relative` style
       * it will cause bug with wrong behaviour of replacing element with <br> tag
       * https://github.com/yola/production/issues/10661
       */
      if (!isElementNode(anchorNode)) return;

      const breakElement = [...anchorNode.children].find((child) => isBreakElement(child));

      if (!breakElement) return;

      const nextEditableElement = findEditableElement(breakElement.nextElementSibling);
      const prevEditableElement = findEditableElement(breakElement.previousElementSibling);

      if (!nextEditableElement && !prevEditableElement) return;

      setCaretInTheEndOfNode(prevEditableElement || nextEditableElement);

      breakElement.remove();

      return;
    }

    // Fix for the native behavior in Chrome.
    const nextEditableElement = findNextEditableElement(editableElement);
    if (!nextEditableElement) return;
    if (!nextEditableElement.innerText && !isTag(nextEditableElement, IMAGE_SELECTOR)) {
      nextEditableElement.remove();
    }
  });
};

export default handleRemoveNextEmptyElement;
